define('TescoMobile_Checkout/js/form/element/clubcard-number',['ko', 'Magento_Ui/js/form/element/abstract', 'Magento_Customer/js/model/customer', 'Magento_Checkout/js/model/quote'], function (ko, Component, customer, quote) {
  'use strict';

  const config = window.checkoutConfig.tescomobile.about;
  return Component.extend({
    defaults: {
      clubcardPointsText: 'You\'ll collect ' + config.clubcard_points + ' points today',
      maxLength: 18,
      integerOnly: true
    },
    initialize: function () {
      this._super();
      this.visible(!customer.isLoggedIn() || customer.isLoggedIn() && !quote.getData('customer_tm_clubcard_on_file'));
    },
    handleKeyDown: function (element, event) {
      const DOT_KEYCODE = 190;
      let keyCodes = [69, 189, 187];
      if (this.integerOnly) {
        keyCodes.push(DOT_KEYCODE);
      }
      return !keyCodes.includes(event.keyCode);
    }
  });
});

